<template>
  <WishesComponent :object="object" :params="params" :key="version" />
</template>

<script setup>
import {ref, onMounted, markRaw, defineOptions} from "vue"
import WishesClass from "./Wishes.js"
import WishesComponent from "./Index"

defineOptions({
  name: "WishlistLayoutWishes"
})

const version = ref(0)

const object = markRaw(new WishesClass())

const params = {
  title: "Все желания на проверку",
  h1: "Желания на проверку",
  page: "wishes_moderate",
}

onMounted(() => {
  version.value++
})
</script>

<style scoped></style>
